export default __webpack_public_path__ + "static/media/playstore.1d8e9d68.png";